import { CustomAxios, CustomAxiosV2 } from "@shared/api/axiosClient";

import type { Schemas } from "@shared/api/types";

export type Vacancy = Schemas["VacancyDTO"];
export type VacancyApplication = Schemas["VacancyApplicationDTO"];

/**
 * El idioma NO viaja como query param desde aca. El interceptor de axios manda
 * `Accept-Language`, Spring lo resuelve en LocaleContextHolder y el backend lo reenvia al
 * middleware de Manatal como `?language=es|en`, que es lo que devuelve las vacantes
 * localizadas. Si alguien saca ese header del interceptor, las vacantes vuelven en el
 * idioma por defecto sin ningun error visible.
 */

// Todas las vacantes (API v2).
export const getVacancies = (): Promise<Vacancy[]> =>
  CustomAxiosV2.get("vacancies/all").then(({ data }) => data);

// Detalle de una vacante (API v2).
export const getVacancy = (id: string): Promise<Vacancy> =>
  CustomAxiosV2.get(`vacancies/${id}`).then(({ data }) => data);

// Export de vacantes a Excel. Devuelve la respuesta completa (data + headers)
// para que la UI arme el archivo con el content-type correcto.
export const downloadVacancies = (): Promise<{ data: Blob; headers: Record<string, string> }> =>
  CustomAxiosV2.get("vacancies/download", { responseType: "blob" });

// Candidatos postulados (API v1).
export const getVacancyApplications = (): Promise<VacancyApplication[]> =>
  CustomAxios.get("vacancy-applications").then(({ data }) => data);

// Postula un candidato a una vacante (multipart, API v2).
export const postVacancyApplication = (formData: FormData): Promise<string> =>
  CustomAxiosV2.post("vacancy-applications", formData).then(({ data }) => data);

// Envía un mensaje de consulta sobre una vacante (API v2).
export const sendVacancyMessage = (vacancyId: string, message: string): Promise<string> =>
  CustomAxiosV2.post(`vacancies/${vacancyId}/send-message/`, { message }).then(({ data }) => data);
